import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// 🔹 Fix default marker icons in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function ContactMap() {
  return (
    <div className="w-full h-[400px] mt-10">
      <MapContainer
        center={[55.6760525, 12.5656775]} // Rådhuspladsen
        zoom={15}
        scrollWheelZoom={false}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* Marker with Popup */}
        <Marker position={[55.6760525, 12.5656775]}>
          <Popup autoOpen autoClose={false} openOn={null}>
            📍 Rådhuspladsen, Copenhagen
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}
